export enum OriginTaxesDescription {
  DEBIT_CARD = 'Cartão de Débito',
  DEBIT_VISA_MASTER = 'Débito Visa/Master',
  DEBIT_VISA_ELECTRON = 'Débito Visa Electron',
  DEBIT_ELO = 'Débito Elo',
  CREDIT_CARD = 'Crédito',
  CREDIT_VISA_MASTER = 'Crédito Visa/Master',
  CREDIT_AMEX = 'Crédito Amex',
  CREDIT_ELO = 'Crédito Elo',
  CASH = 'Dinheiro',
  PIX = 'Pix',
  TICKET = 'Boleto',
  ALL = 'Outros',
  VALE_ALIMENTACAO = 'Vale Alimentação',
  VALE_REFEICAO = 'Vale Refeição',
  MAIN = 'Taxa Default(Caso não tenha configuração)',
  CREDIT_PARCELLED = 'Adicional por Parcela',
  WITHDRAWAL = 'Taxa de Saque',
  INTEGRATION_TICKET = 'Integração Boleto',
  INTEGRATION_PIX = 'Integração Pix',
  INTEGRATION_CREDIT_CARD = 'Integração Cartão de Crédito',
  INTEGRATION_DEBIT_CARD = 'Integração Cartão de Débito',
  INTEGRATION_CASH = 'Integração Dinheiro',
  SPREAD = 'Spread',
  VOUCHER = 'Voucher',
  DEPOSIT_PIX = 'Depósito PIX',
  DEPOSIT_CREDIT = 'Depósito Cartão',
}

export enum TaxesOriginType {
  'ALL' = 'ALL',
  'DEBIT_VISA_ELECTRON' = 'DEBIT_VISA_ELECTRON',
  'DEBIT_CARD' = 'DEBIT_CARD',
  'DEBIT_VISA_MASTER' = 'DEBIT_VISA_MASTER',
  'DEBIT_ELO' = 'DEBIT_ELO',
  'CREDIT_CARD' = 'CREDIT_CARD',
  'CREDIT_AMEX' = 'CREDIT_AMEX',
  'CREDIT_VISA_MASTER' = 'CREDIT_VISA_MASTER',
  'CREDIT_ELO' = 'CREDIT_ELO',
  'CASH' = 'CASH',
  'PIX' = 'PIX',
  'MAIN' = 'MAIN',
  'WITHDRAWAL' = 'WITHDRAWAL',
  'TICKET' = 'TICKET',
  'CREDIT_PARCELLED' = 'CREDIT_PARCELLED',
  'INTEGRATION_TICKET' = 'INTEGRATION_TICKET',
  'INTEGRATION_PIX' = 'INTEGRATION_PIX',
  'INTEGRATION_CREDIT_CARD' = 'INTEGRATION_CREDIT_CARD',
  'INTEGRATION_DEBIT_CARD' = 'INTEGRATION_DEBIT_CARD',
  'INTEGRATION_CASH' = 'INTEGRATION_CASH',
  'VALE_ALIMENTACAO' = 'VALE_ALIMENTACAO',
  'VALE_REFEICAO' = 'VALE_REFEICAO',
  'VOUCHER' = 'VOUCHER',
  'DEPOSIT_PIX' = 'DEPOSIT_PIX',
  'DEPOSIT_CREDIT' = 'DEPOSIT_CREDIT',
}

export enum TaxesType {
  FIXED = 'FIXED',
  PERCENTUAL = 'PERCENTUAL',
}

export enum TaxesTypeDescriptions {
  FIXED = 'Fixa',
  PERCENTUAL = 'Porcentagem',
}
